<div class="quote-container">
  <table class="table table--full-width">
    <thead>
      <tr>
        <th></th>
        <th>{{'Rule' | translate | async}}</th>
        <th>{{'Component Type' | translate | async}}</th>
        <th>{{'Side' | translate | async}}</th>
        <th>{{'Pos.' | translate | async}}</th>
        <th>{{'Action Type' | translate | async}}</th>
        <th>{{'Comment' | translate | async}}</th>
        <!--<th>Attach</th>-->
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let rule of RuleDetails">
        <td style="align-content: center;">
          <mat-checkbox [disabled]="rule.RuleAttached" [title]="rule.RuleAttached ? 'Already attached!!' : 'Click to attach rule.'" (change)="attachRuleComponent(rule.RuleSelected, rule.RuleComponentId)" [(ngModel)]="rule.RuleSelected">
          </mat-checkbox>
        </td>
        <td>{{rule.RuleName}}</td>
        <td>{{rule.ComponentType}}</td>
        <td>{{rule.Side}}</td>
        <td>{{rule.Position}}</td>
        <td>{{rule.ActionType}}</td>
        <td><span [matTooltip]="rule.Description">{{rule.Description | slice:0:20}}{{rule.Description.length > 20 ? '...' : ''}}</span></td>
        <!--<td style="align-content: center;">
          <mat-checkbox [disabled]="rule.RuleAttached" [title]="rule.RuleAttached ? 'Already attached!!' : 'Click to attach rule.'" (change)="attachRuleComponent(rule.RuleSelected, rule.RuleComponentId)" [(ngModel)]="rule.RuleSelected">
          </mat-checkbox>
        </td>-->
      </tr>
    </tbody>
  </table>
</div>
